import styled, { css } from 'styled-components';
import { theme } from 'styles';

const diagonalCss = css`
  .ant5-upload-list.ant5-upload-list-text {
    display: flex !important;
    flex-wrap: wrap;
    gap: 8px;
  }
`;

export const UploadWrapper = styled.div<{ fileListType: 'diagonal' | 'vertical' }>`
  ${({ fileListType }) => fileListType === 'diagonal' && diagonalCss};
  .ant5-upload-list-text .ant5-upload-list-item-done a {
    color: ${theme.color.clear_blue} !important;
  }
`;
